import type { StatusTone } from '../components/ui';
import type {
  IssueReportCategory,
  IssueReportPriority,
  IssueReportReporterType,
  IssueReportStatus,
} from '../services/issue-report.service';

export const ISSUE_REPORT_CATEGORY_OPTIONS: Array<{ value: IssueReportCategory; label: string }> = [
  { value: 'GENERAL_ISSUE', label: 'General Issue' },
  { value: 'BUG', label: 'Bug' },
  { value: 'IMPROVEMENT', label: 'Improvement Suggestion' },
  { value: 'FEATURE_REQUEST', label: 'Feature Request' },
];

export const ISSUE_REPORT_STATUS_OPTIONS: Array<{ value: IssueReportStatus; label: string }> = [
  { value: 'SUBMITTED', label: 'Submitted' },
  { value: 'UNDER_REVIEW', label: 'Under Review' },
  { value: 'PLANNED', label: 'Planned' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'IMPLEMENTED', label: 'Implemented' },
  { value: 'CLOSED', label: 'Closed' },
];

export const ISSUE_REPORT_PRIORITY_OPTIONS: Array<{ value: IssueReportPriority; label: string }> = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
  { value: 'CRITICAL', label: 'Critical' },
];

const categoryLabels: Record<IssueReportCategory, string> = {
  GENERAL_ISSUE: 'General Issue',
  BUG: 'Bug',
  IMPROVEMENT: 'Improvement',
  FEATURE_REQUEST: 'Feature Request',
};

const statusMeta: Record<IssueReportStatus, { label: string; tone: StatusTone }> = {
  SUBMITTED: { label: 'Submitted', tone: 'anchored' },
  UNDER_REVIEW: { label: 'Under Review', tone: 'suspicious' },
  PLANNED: { label: 'Planned', tone: 'ai-flagged' },
  IN_PROGRESS: { label: 'In Progress', tone: 'active' },
  IMPLEMENTED: { label: 'Implemented', tone: 'active' },
  CLOSED: { label: 'Closed', tone: 'muted' },
};

const priorityMeta: Record<IssueReportPriority, { label: string; tone: StatusTone }> = {
  LOW: { label: 'Low', tone: 'muted' },
  MEDIUM: { label: 'Medium', tone: 'anchored' },
  HIGH: { label: 'High', tone: 'suspicious' },
  CRITICAL: { label: 'Critical', tone: 'recalled' },
};

const reporterLabels: Record<IssueReportReporterType, string> = {
  MANUFACTURER: 'Manufacturer',
  OPERATIONS_MANAGER: 'Operations Manager',
  ADMIN: 'Admin',
};

export const getIssueReportCategoryLabel = (category: IssueReportCategory): string => categoryLabels[category];

export const getIssueReportStatusMeta = (status: IssueReportStatus) => statusMeta[status];

export const getIssueReportPriorityMeta = (priority: IssueReportPriority) => priorityMeta[priority];

export const getIssueReportReporterLabel = (reporterType: IssueReportReporterType): string => reporterLabels[reporterType];
